import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import ProductComponent from "./components/ProductComponent";
import StepComponent from "./components/StepComponent";
import HeaderComponent from "./components/HeaderComponent";
import filterProds from "./assets/filterCmp";
import FilterBar from "./components/FilterBar";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import loadURLProds from "./assets/loadProds";
import fetchProd from "./assets/fetchProd";
import fetchProds from "./assets/fetchProds";
import FinalStep from "./components/FinalStep";

const FILTERS_BY_TAG = {
    cpu: [
        { label: 'AMD', value: 'amd', match: (prod) => /amd/i.test(prod.name) },
        { label: 'Intel', value: 'intel', match: (prod) => /intel/i.test(prod.name) },
    ],
    disco: [
        { label: 'SSD', value: 'ssd', match: (prod) => /ssd/i.test(prod.name) },
        { label: 'HDD', value: 'hdd', match: (prod) => /hd/i.test(prod.name) },
    ],
    cooler: [
        { label: 'Water Cooler', value: 'water', match: (prod) => prod.features?.find(f => f.name === 'tipo_cooler')?.value === 'refrigeracion-liquida' },
        { label: 'Air Cooler', value: 'air', match: (prod) => prod.features?.find(f => f.name === 'tipo_cooler')?.value === 'aire' },
    ],
};

const OUTLET_TAGS = ['cpu', 'mother', 'ram', 'disco', 'gpu', 'fuente'];

const skeletons = [
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>,
    <Skeleton className="producto"/>
]

function App() {

    const [products, setProducts] = useState([]);
    const [fProducts, setFProducts] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [steps, setSteps] = useState([
        {
            "id": 15,
            "tag": "final",
            "nombre": "Finalizar",
            "descripcion": "Revisá que todos los componentes estén correctos. Si estás conforme con la configuración, hacé clic en \"Comprar ahora\" y tu PC se agregará automáticamente al carrito."
        },
        {
            "id": 1,
            "tag": "cpu",
            "nombre": "Procesador",
            "required": true,
            "descripcion": "El procesador es el corazón del sistema. Tu elección va a influir directamente en la velocidad y capacidad de respuesta de tu computadora.",
            "category_id": ["procesadores", "procesadores-outlet"],
            "multiple": false
        },
        {
            "id": 2,
            "tag": "mother",
            "nombre": "Motherboard",
            "required": true,
            "descripcion": "Es la base donde se ensamblan y comunican todos los componentes. Un buen mother asegura estabilidad y opciones de expansión.",
            "category_id": ["motherboards", "motherboards-outlet"],
            "multiple": false
        },
        {
            "id": 3,
            "tag": "cooler",
            "nombre": "Cooler",
            "required": false,
            "descripcion": "El cooler mantiene a tu procesador a buena temperatura y alarga su vida útil. Es esencial para evitar sobrecalentamientos y asegurar un buen rendimiento.",
            "category_id": "coolers-y-refrigeracion",
            "multiple": false
        },
        {
            "id": 4,
            "tag": "ram",
            "nombre": "Memoria",
            "required": true,
            "descripcion": "La memoria RAM permite que tu PC trabaje con varias tareas al mismo tiempo. Elegí buena capacidad y velocidad según el uso que le vayas a dar.",
            "category_id": ["memorias-ram", "memorias-ram-outlet"],
            "multiple": true
        },
        {
            "id": 5,
            "tag": "gpu",
            "nombre": "Placa de Video",
            "required": false,
            "descripcion": "La Placa de video se encarga de los gráficos, liberando al procesador de las tareas visuales más pesadas. Invertir en una buena puede marcar la diferencia en rendimiento.",
            "category_id": ["placas-de-video", "placas-de-video-outlet"],
            "multiple": false
        },
        {
            "id": 6,
            "tag": "disco",
            "nombre": "Almacenamiento",
            "required": true,
            "descripcion": "El almacenamiento define cuánta información podés guardar y con qué velocidad accedés a ella. Elegí SSD si buscás velocidad o HDD si necesitás mucho espacio a bajo costo.",
            "category_id": ["almacenamiento-ssd-hdd", "almacenamiento-outlet"],
            "multiple": true
        },
        {
            "id": 7,
            "tag": "fuente",
            "nombre": "Fuente",
            "required": true,
            "descripcion": "La fuente es la encargada de alimentar al resto de los componentes y va a ser uno de los factores a tener en cuenta si querés armar una PC potente.",
            "category_id": ["fuentes-de-alimentacion", "fuentes-outlet"],
            "multiple": false
        },
        {
            "id": 8,
            "tag": "gab",
            "nombre": "Gabinete",
            "required": true,
            "descripcion": "El gabinete protege y organiza todos los componentes. Influye en el rendimiento general de tu PC.",
            "category_id": "gabinetes",
            "multiple": false
        },
        {
            "id": 9,
            "tag": "arm",
            "nombre": "Armado",
            "required": true,
            "descripcion": "Nuestros técnicos especializados se encargarán de ensamblar y probar tu equipo para que funcione perfectamente desde el primer día.",
            "category_id": "servicios",
            "multiple": false
        }
    ]);
    const [currentStep, setCurrentStep] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [activeFilter, setActiveFilter] = useState(null);
    const [showOutlet, setShowOutlet] = useState(true);

    const toggleFilter = (value) => {
        setActiveFilter(prev => prev === value ? null : value);
    }

    useEffect(() => {
        setActiveFilter(null);
    }, [currentStep.id]);

    useEffect(() => {
        setIsLoading(true);
    }, [searchParams.get('step')]);
    
    useEffect(() => {
        loadURLProds(steps, products, setSteps, fetchProd, searchParams, setSearchParams);

        if(!searchParams.get('step')) {
            searchParams.set('step', 1);
            return setSearchParams(searchParams, { replace: true });
        }

        let findStep = steps.find(step => step.id === Number(searchParams.get('step')));

        if(findStep)
            setCurrentStep(findStep);

        if(!findStep) {
            searchParams.set('step', 15);
            setSearchParams(searchParams, { replace: true });
        }

        if(findStep && !products.find(prods => prods.id === findStep.category_id) && findStep.tag !== 'final')
            fetchProds(findStep, setProducts, filterProds, setSteps, setFProducts, setIsLoading);
        else if(findStep && products.find(prods => prods.id === findStep.category_id) && findStep.tag !== 'final')
            filterProds({...findStep, data: products.find(prod => prod.id === findStep.category_id)?.data}, setSteps, setFProducts, setIsLoading);
    }, [searchParams, setSteps, products]);

    return (
        <main className="container">
            <HeaderComponent steps={steps} currentStep={currentStep} setSteps={setSteps} />
            <div className="prods-container">
                <div className="steps">
                    { steps.map(step => <StepComponent step={step} currentStep={currentStep} />)}
                </div>
                {
                    currentStep.tag !== 'final' ? 
                        <div className="products" id="products">
                            {
                                currentStep.tag === 'gpu' &&
                                    steps.find(step => step.tag === 'cpu')?.data?.features?.find(f => f.name === 'graficos_integrados')?.value === false &&
                                    <div className="gpu-warning">
                                        El procesador que elegiste no tiene gráficos integrados. Vas a necesitar una placa de video para poder usar la PC (salvo que ya tengas una propia).
                                    </div>
                            }
                            {
                                (FILTERS_BY_TAG[currentStep.tag] || OUTLET_TAGS.includes(currentStep.tag)) &&
                                    <FilterBar
                                        options={FILTERS_BY_TAG[currentStep.tag]}
                                        active={activeFilter}
                                        onToggle={toggleFilter}
                                        showOutlet={showOutlet}
                                        onToggleOutlet={setShowOutlet}
                                        showOutletToggle={OUTLET_TAGS.includes(currentStep.tag)}
                                    />
                            }
                            { 
                                !isLoading ?
                                    fProducts.id === currentStep.category_id && fProducts.data && fProducts.data.filter(prod => {
                                            const filters = FILTERS_BY_TAG[currentStep.tag];
                                            const matchesQuickFilter = !activeFilter || !filters || filters.find(f => f.value === activeFilter)?.match(prod);
                                            const matchesOutlet = !OUTLET_TAGS.includes(currentStep.tag) || showOutlet || !prod.is_outlet;
                                            return matchesQuickFilter && matchesOutlet;
                                        }).map(prod => <ProductComponent prod={prod} steps={steps} setSteps={setSteps} setIsLoading={setIsLoading} fProducts={fProducts} />)
                                    : skeletons
                            }
                        </div> :
                        <FinalStep steps={steps} />
                }
            </div>   
        </main>
    );
}

export default App;